import * as Sentry from "@sentry/react"
import { Route, Switch } from "wouter"

import "./styles/global.css"
import { TheAnyThingLogo } from "./components/TheAnyThingLogo"
import { Announcements } from "./pages/announcements"
import { Room } from "./pages/room"
import { Timetable } from "./pages/timetable"
import { TimetableV2 } from "./pages/timetable-v2"

function App() {
  return (
    <Sentry.ErrorBoundary>
      <Switch>
        <Route path="/announcements/:locationId/:roomIds" component={Announcements} />
        <Route path="/room/:locationId/:roomId" component={Room} />
        <Route path="/timetable/:locationId/:roomIds" component={Timetable} />
        <Route path="/timetable-v2/:locationId/:roomIds" component={TimetableV2} />
        <Route>
          <TheAnyThingLogo />
        </Route>
      </Switch>
    </Sentry.ErrorBoundary>
  )
}

export default App
